import { render } from "./Downloads.vue?vue&type=template&id=5cec6118&lang=pug"
import script from "./Downloads.vue?vue&type=script&setup=true&lang=js"
export * from "./Downloads.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__